import styled from 'styled-components';
import { LongLogoLink } from '../Logo/LongLogoLink';

export const NAVBAR_HEIGHT = 64;

const StyledTopNavbar = styled.div`
  background-color: var(--surface-100);
  display: flex;
  height: ${NAVBAR_HEIGHT}px;
  padding: 0px 24px;
  justify-content: space-between;
  align-items: center;
`;

const NavbarSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
`;

/**
 * Bar that sits on top of the page
 */
export const TopNavbar = ({
  leftNavbarSection,
  rightNavbarSection,
}: {
  // Defaults to the long tandem logo
  leftNavbarSection?: React.ReactNode;
  rightNavbarSection?: React.ReactNode;
}) => {
  return (
    <StyledTopNavbar>
      {leftNavbarSection ?? <LongLogoLink />}

      {rightNavbarSection && <NavbarSection>{rightNavbarSection}</NavbarSection>}
    </StyledTopNavbar>
  );
};
